<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="searchDate"
                    :format="getDefaultDateFormat" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select placeholder="Ex: Value's < 100 Million Rupiah" v-model="kategori" class="width-full"
                    allowClear>
                    <a-select-option value="less">Value's &#60; 100 Million Rupiah</a-select-option>
                    <a-select-option value="over">Value's &#62;= 100 Million Rupiah</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option v-for="item in getStatusWO" :key="item.id" :value="item.value">{{ item.label
                    }}</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Supplier</label>
                  <a-select showSearch v-model="supplier_nm" placeholder="Select Supplier Name ..." class="width-full"
                    initialValue="delivered" allowClear>
                    <a-select-option v-for="item in wo_supplier" :key="item" :value="item">{{ item }}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="Work Order List" :manifestLink="getManifestLink" :dataList="searching"
        :estimasi="false" :disabledCreateEditLink="true" :isMonitoring="true">
          <div slot="slot_extra">
            <a-button type="primary" icon="download" @click="showExport()">Export</a-button>
          </div>
        </DataList>
    </a-col>

    <a-modal v-model="exporting.visible" @ok="handleExport">
      <span slot="title"> <a-icon type="download" />&nbsp;Export </span>

      <div class="m-form-item-wrapper">
        <a-form-model
          ref="formExport"
          :model="exporting.form"
          :rules="exporting.rules"
          class="steps-content m-flex1"
        >
          <a-form-model-item label="Transaction Date" prop="transactionDt">
            <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="exporting.form.transactionDt"
              :format="getDefaultDateFormat" />
          </a-form-model-item>
        </a-form-model>
      </div>

      <template slot="footer">
        <a-button key="submit" type="primary" class="m-width-full"
          @click="handleExport" :loading="exporting.loading">
          Submit
        </a-button>
      </template>
    </a-modal>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "listWO",
  mixins: [CurrencyFormat, GlobalMethod],
  props: ["prnMenu"],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      kategori: undefined,
      searchDate: [],
      search: "",
      status: undefined,
      wo_supplier: [],
      supplier_nm: undefined,
      exporting:{
        visible: false,
        loading: false,
        form:{
          transactionDt: null
        },
        rules:{
          transactionDt: [{ required: true, message: 'Transaction Date is Required!', trigger: "change" }],
        }
      }
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatusWO",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate && this.searchDate.length > 0) {
        let startDt = moment(this.searchDate[0]).format(this.getDefaultDateFormat);
        let endDt = moment(this.searchDate[1]).format(this.getDefaultDateFormat);

        outputData = outputData.filter(
          (obj) =>
            obj.tgl_buat &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) >= startDt &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) <= endDt
        );
      }

      if (this.kategori) {
        outputData = outputData.filter((item) => {
          return this.kategori == "less" ? item.estimated_valueRP < 100000000 : item.estimated_valueRP >= 100000000;
        });
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) => obj.status.toLowerCase().indexOf(self.status.toLowerCase()) >= 0
        );
      }

      if (this.supplier_nm) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.supplier &&
            obj.supplier
              .toLowerCase()
              .indexOf(this.supplier_nm.toLowerCase()) >= 0
        );
      }

      return outputData;
    },
    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/keuangan") {
        return "SpclWOManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        return "SpclWOManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        return "SpclWOManifestAL";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        return "SpclWOManifestDir";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclWOManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/ga") {
        return "SpclWOManifestGA";
      } else if (localStorage.getItem("nvpn") === "/purchasing") {
        return "SpclWOManifestPurchasing";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclWOManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclWOManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclWOManifestFin";
      } else {
        return "SpclWOManifest";
      }
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/wo",
        params: {
          id: localStorage.getItem("nvky"),
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.basedList = response.data.data;

          _.forEach(response.data.data, (data) => {
            this.dataList.push({
              title: data.no_wo + " | " + data.tlc_pembuat,
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: [
                data.no_pp,
                { deskripsi: data.deskripsi },
                data.supplier,
                this.formatCurrency(data.mata_uang, data.estimated_value),
              ],
              status: data.status,
              id: data.id_wo,
              estimated_value: data.estimated_value,
              estimated_valueRP: data.estimated_valuerp,
              tgl_buat: data.tgl_buat,
              peruntukan: data.peruntukan,
              supplier: data.supplier,
              searchQ:
                data.no_wo +
                " " +
                data.no_pp +
                " " +
                data.tlc_pembuat +
                " " +
                data.supplier +
                " " +
                data.mata_uang +
                " " +
                data.estimated_value +
                " " +
                data.deskripsi,
              closed_po_wo: data.close_sts,
            });
          });

          this.dataList.forEach((element) => {
            if (this.wo_supplier.indexOf(element.supplier) === -1) {
              this.wo_supplier.push(element.supplier);
            }
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    showExport(){
      this.exporting.form.transactionDt = null
      this.exporting.visible = true
    },
    handleExport(){
      this.$refs.formExport.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        const start_dt = moment(this.exporting.form.transactionDt[0]).format(this.getStandartFormatDate)
        const end_dt   = moment(this.exporting.form.transactionDt[1]).format(this.getStandartFormatDate)
        this.exporting.loading = true
        this.asyncAxiosGet("wo/export",
          this.getAuth,
          {
            start_date: start_dt,
            end_date: end_dt,
          }
        ).then((res) => {
          let data_export = [];

          res.data.forEach((item,index)=> {
            data_export.push({
              "No." : index+1,
              "No. WO" : item.no_wo,
              "TLC" : item.user_create,
              "Project Code" : item.kode_project,
              "No. PP" : item.no_pp,
              "Supplier" : item.nama_supplier,
              "Location" : item.lokasi,
              "Description" : item.deskripsi,
              "Currency" : item.currency,
              "Value WO" : item.value_wo,
              "Note" : item.catatan,
              "Create Date" : moment(item.date_create).format(this.getStandartFormatDate),
              "Start Date" : moment(item.tgl_mulai).format(this.getStandartFormatDate),
              "End Date" : item.tgl_selesai ? moment(item.tgl_selesai).format(this.getStandartFormatDate) :''
            })
          })
          const workbook = this.$XLSX.utils.book_new();
          const worksheet = this.$XLSX.utils.json_to_sheet(data_export);
          /* Calculate maximum width for each column :: auto width*/
          // const columnSizes = data_export.reduce((acc, row) => {
          //   Object.keys(row).forEach((key, i) => {
          //     const headertextLength = key.length;
          //     const rowtextLength = row[key].toString().length
          //     const value = row[key] ? (headertextLength > rowtextLength ? headertextLength : rowtextLength) : 0;
          //     if (!acc[i] || value > acc[i]) {
          //       acc[i] = value;
          //     }
          //   });
          //   return acc;
          // }, []);
          // worksheet['!cols'] = columnSizes.map(width => ({ wch: width + 2 }));

          this.$XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          this.$XLSX.writeFile(workbook, "WO_"+start_dt+"_"+end_dt+".xlsx");

          this.exporting.loading = false
          this.exporting.visible = false
        }).catch(() => {
        });
      })
    }
  },
};
</script>

<style></style>